export default {
  ReportReceipt: 0, // báo cáo theo chỉ tiêu thu
  ReportExpense: 1, // báo cáo theo chỉ tiêu chi
  ReportSymmetrical: 2, // báo cáo cân đối theo NDKT
};
